import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { findItemByPath } from '../navigation/navigation';
import { PageHeader } from '../components/PageHeader';
import { EmptyState } from '../components/states/StateViews';

/**
 * Stands in for a destination whose milestone has not landed.
 *
 * Every navigation entry is declared at Milestone 0 so role-based navigation can be built and
 * tested for real. Rather than let those entries 404, they land here and say which milestone
 * brings the screen — honest to the owner reviewing progress, and a working link for anyone
 * exploring the information architecture.
 */
export function PlaceholderPage() {
  const { t } = useTranslation();
  const location = useLocation();
  const item = findItemByPath(location.pathname);

  const title = item ? t(`nav.items.${item.key}`) : t('states.empty.title');

  // PageHeader carries the title, so the empty state below states the milestone rather than
  // repeating the name of the screen underneath itself.
  return (
    <>
      <PageHeader title={title} />
      <EmptyState
        title={item ? t('states.notYetBuilt.title', { milestone: item.milestone }) : t('states.empty.title')}
        description={item ? t('states.notYetBuilt.description') : t('states.empty.description')}
      />
    </>
  );
}
